// extracted by mini-css-extract-plugin
export var col = "DownloadsWallpaper-module--col--js5V6";
export var container = "DownloadsWallpaper-module--container--C8SV5";
export var header = "DownloadsWallpaper-module--header--VO+ag";
export var row = "DownloadsWallpaper-module--row--S9Gaj";
export var section = "DownloadsWallpaper-module--section--qNcW+";
export var sectionBg = "DownloadsWallpaper-module--section-bg--eH7HV";